exports = module.exports = require("../../../../node_modules/@zxcabs/rtl-css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".comparison-limit-header{text-align:center;font-size:24px;font-weight:300;line-height:30px;padding:2vw 2vw 1vw}.comparison-limit-subheader{text-align:center;font-size:20px;line-height:25px;color:#620832;padding:0 1vw 2vw}.modal-footer-action-btn .btn-move-to{color:#fff;background:#53b8d4}.modal-footer-action-btn .btn-move-to:focus,.modal-footer-action-btn .btn-move-to:hover{background:#1fa2c7}", ""]);

// exports
